import React from "react"
import Icon from "../../../../components/AppIcon"

const TONE_STYLES = {
  positive: "bg-success/10 text-success border-success/20",
  negative: "bg-error/10 text-error border-error/20",
  neutral: "bg-muted text-foreground border-border",
}

const InsightsStrip = ({ insights, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:col-span-4">
        {Array.from({ length: 2 })?.map((_, i) => (
          <div key={i} className="h-16 rounded-xl bg-muted animate-pulse" />
        ))}
      </div>
    )
  }

  if (!insights?.length) return null

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:col-span-4">
      {insights.map((insight) => (
        <div
          key={insight.id}
          className={`flex items-start gap-3 rounded-xl border px-4 py-3 ${
            TONE_STYLES[insight.tone] || TONE_STYLES.neutral
          }`}
        >
          <Icon name={insight.icon} size={16} className="mt-0.5 shrink-0" />
          <p className="text-sm leading-snug">{insight.text}</p>
        </div>
      ))}
    </div>
  )
}

export default InsightsStrip